export class Area {
  constructor({ areaId, unidadeId, nome }) {
    this.areaId = areaId;
    this.unidadeId = unidadeId;
    this.nome = nome;
  }
}
